import { Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges, inject } from '@angular/core'
import { Step } from './interfaces/step.interface'
import { SMSStepperStep } from '../sms-onboarding/models/sms-onboarding.model'
import { SidebarStep } from '../../../core/modules/sidebar-stepper/sidebar-stepper.interface'
import { NavigationEnd, Router } from '@angular/router'
import { filter } from 'rxjs/operators'
import { Subscription } from 'rxjs'
import { TranslocoService } from '@jsverse/transloco'

@Component({
    selector: 'pf-steps-panel',
    templateUrl: './steps-panel.component.html',
    styleUrls: ['./steps-panel.component.scss'],
    standalone: false
})
export class StepsPanelComponent implements OnInit, OnChanges, OnDestroy {
  private static readonly STEP_LABEL_KEYS: Record<string, string> = {
    Theme: 'email_automation_builder.common.step_theme',
    Design: 'email_automation_builder.common.step_design',
    Offer: 'email_automation_builder.common.step_offer',
    Triggers: 'email_automation_builder.common.step_triggers',
    Settings: 'email_automation_builder.common.step_settings',
    Template: 'email_automation_builder.common.step_template',
  }

  private transloco = inject(TranslocoService)

  @Input() steps: Step[] | SMSStepperStep[] | SidebarStep[] = [];
  @Input() expanded: boolean;
  @Input() nonSequentialNav: boolean = false;
  @Input() stepsClickable: boolean = true;
  @Input() multiline: boolean = false;
  currentStep: any = {}
  subscription = new Subscription()

  constructor(private router: Router) {
    this.subscription.add(
      this.router.events.pipe(filter(event => event instanceof NavigationEnd))
        .subscribe(() => this.selectCurrentStep())
    )

  }

  ngOnInit() {
    this.selectCurrentStep()
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes?.steps?.currentValue) {
      this.selectCurrentStep()
    }
  }

  ngOnDestroy() {
    this.subscription.unsubscribe()
  }

  onStepClick(selectedStep) {
    this.selectCurrentStep(selectedStep?.url)
  }

  private selectCurrentStep(_url = null) {
    const url = _url || this.router.url.split('/').pop()
    this.steps?.forEach((step, i) => {
      const shortenedPath = step.url.split('/').pop()
      if (url === step.url || url === shortenedPath) {
        this.currentStep = { ...step, index: i }
      }
    })
  }

  stepLabelKey(label: string | undefined): string | null {
    if (!label) {
      return null
    }
    if (label.includes('.')) {
      return label
    }
    return StepsPanelComponent.STEP_LABEL_KEYS[label] ?? null
  }

  invalidStepTooltip(step: Step): string {
    if (!step?.invalid || !step.invalid_message) {
      return ''
    }
    return this.transloco.translate(step.invalid_message)
  }
}
